import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  // IconButton
} from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

const MobileRestrictionDialog = ({ open, onClose }) => {
  const { t } = useTranslation('translation');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="mobile-restriction-dialog-title"
      aria-describedby="mobile-restriction-dialog-description"
    >
      <DialogTitle id="mobile-restriction-dialog-title">
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Typography variant="h4" color="#000" sx={{ fontWeight: 600 }}>
            {t("We're sorry...")}
          </Typography>
         
        </Box>
      </DialogTitle>
      
      <DialogContent sx={{ paddingTop: '12px !important' }}>
        <Typography 
          id="mobile-restriction-dialog-description"
          variant="body1"
          sx={{ 
            textAlign: 'center',
            fontSize: '16px',
            lineHeight: 1.5,
            color: '#333'
          }}
        >
          {t("You can't access this on Mobile device. Please switch to Desktop / Laptop.")}
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: 'center', paddingBottom: '24px' }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: '#437bfc',
            color: '#fff',
            borderRadius: '8px',
            paddingX: '24px',
            paddingY: '8px',
            textTransform: 'none',
            fontWeight: 500,
           ":hover": {
              color: '#437bfc',
                  border: '1px solid #437bfc',
                  background: '#fff',
            },
              ':active': {
              color: '#437bfc',
              border: '1px solid #437bfc',
              backgroundColor: '#fff',
            },
          }}
        >
          {t("Close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MobileRestrictionDialog;
